import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faShareAlt } from '@fortawesome/free-solid-svg-icons';
import './PackageShare.css';
import PdfPreviewModal from './PdfPreviewModal'; // Import the new modal component

const PackageShare = ({ packageId, itineraryData }) => {
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);
  const [selectedPdfData, setSelectedPdfData] = useState(null);

  // This function will now open the preview modal
  const handleViewPdf = (templateName) => {
    console.log(`Viewing PDF with template: ${templateName}`);
    setSelectedPdfData({
      template: templateName,
      data: itineraryData,
    });
    setIsPdfModalOpen(true);
  };
  
  const handleCloseModal = () => {
    setIsPdfModalOpen(false);
    setSelectedPdfData(null);
  };

  // This function will handle the email sharing logic (for later)
  const handleShare = (templateName) => {
    console.log(`Sharing PDF with template: ${templateName}`);
    alert(`This will open an email modal to share the "${templateName}" PDF.`);
  };

  if (!itineraryData) {
    return (
      <div className="package-share-container">
        <p className="text-muted">No itinerary data available. Please go back and generate an itinerary first.</p>
      </div>
    );
  }

  return (
    <>
      <div className="package-share-container">
        <h5>Select a PDF Template to Share</h5>
        <p className="text-muted">
          Choose a layout to generate a PDF document or share it directly with the customer.
        </p>
        
        <div className="pdf-templates-grid">
          {/* Template Card 1 */}
          <div className="pdf-template-card">
            <img src="https://via.placeholder.com/300x420.png?text=Classic+Layout" alt="Classic PDF Template" className="template-thumbnail" />
            <h6>Classic Template</h6>
            <p className='template-description'>A clean, professional layout focusing on readability and details.</p>
            <div className="template-actions">
              <button className="btn btn-outline-primary btn-sm" onClick={() => handleViewPdf('Classic')}>
                <FontAwesomeIcon icon={faEye} /> View
              </button>
              <button className="btn btn-primary btn-sm" onClick={() => handleShare('Classic')}>
                <FontAwesomeIcon icon={faShareAlt} /> Share
              </button>
            </div>
          </div>

          {/* Template Card 2 */}
          <div className="pdf-template-card">
            <img src="https://via.placeholder.com/300x420.png?text=Modern+Design" alt="Modern PDF Template" className="template-thumbnail" />
            <h6>Modern Design</h6>
            <p className='template-description'>A visually appealing design with larger images and a focus on style.</p>
            <div className="template-actions">
              <button className="btn btn-outline-primary btn-sm" onClick={() => handleViewPdf('Modern')}>
                <FontAwesomeIcon icon={faEye} /> View
              </button>
              <button className="btn btn-primary btn-sm" onClick={() => handleShare('Modern')}>
                <FontAwesomeIcon icon={faShareAlt} /> Share
              </button>
            </div>
          </div>

          {/* Template Card 3 */}
          <div className="pdf-template-card">
            <img src="https://via.placeholder.com/300x420.png?text=Compact+View" alt="Compact PDF Template" className="template-thumbnail" />
            <h6>Compact Itinerary</h6>
            <p className='template-description'>A condensed, summary-focused view perfect for a quick overview.</p>
            <div className="template-actions">
              <button className="btn btn-outline-primary btn-sm" onClick={() => handleViewPdf('Compact')}>
                <FontAwesomeIcon icon={faEye} /> View
              </button>
              <button className="btn btn-primary btn-sm" onClick={() => handleShare('Compact')}>
                <FontAwesomeIcon icon={faShareAlt} /> Share
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Conditionally render the modal */}
      <PdfPreviewModal
          isOpen={isPdfModalOpen}
          onClose={handleCloseModal}
          pdfData={selectedPdfData}
      />
    </>
  );
};

export default PackageShare;